import { SELECT_PROJECT, REFRESH_PROJECT } from "../actionTypes";

export const selectProject = (projectId) => ({
  type: SELECT_PROJECT,
  payload: projectId,
});

export const refreshProject = () => ({
  type: REFRESH_PROJECT,
  payload: Date.now(), // Use timestamp to ensure the value changes each time
});

